(function () {
  var QUESTIONS = [
    { q: 'How often do you pump?', options: [
      { label: 'Just once or twice a day, or when I need to', airy: 2, libre: 0 },
      { label: "Multiple times a day, I'm an exclusive pumper", airy: 0, libre: 2 }
    ]},
    { q: 'What matters more to you right now?', options: [
      { label: "Feeling like I'm barely wearing anything", airy: 2, libre: 0 },
      { label: "Pumping a full session's worth in one go", airy: 0, libre: 2 }
    ]},
    { q: 'Have you ever struggled with uneven supply between sides?', options: [
      { label: "Yes, it's been a real issue", airy: 0, libre: 2 },
      { label: 'Not really / not sure', airy: 0, libre: 0 }
    ]},
    { q: 'How do you want to adjust settings mid-pump?', options: [
      { label: "Just tap the pump itself, that's fine", airy: 1, libre: 0 },
      { label: 'Without lifting my clothes, remote control', airy: 0, libre: 2 }
    ]},
    { q: 'Where do you usually pump?', options: [
      { label: 'On the go — commuting, meetings, out with the baby', airy: 2, libre: 0 },
      { label: 'At home or my desk, sitting down for it', airy: 0, libre: 1 }
    ]}
  ];

  var RESULT_COPY = {
    airy: {
      title: "You're an Airy.",
      body: "Freedom, barely-there. 200g of nothing-on-your-chest comfort, with a Bionic Infant Sucking mode that feels like your baby, not a machine."
    },
    libre: {
      title: "You're a Libre.",
      body: "Built for volume. 8oz capacity, 3.5 hours of battery, and remote-controlled sync so both sides finally pump evenly."
    }
  };

  function initQuiz(root) {
    var sectionId = root.getAttribute('data-section-id') || root.closest('[id^="shopify-section"]');
    var data = (window.quizSectionData && window.quizSectionData[root.dataset.quizId]) || {};

    var panels = {
      intro: root.querySelector('[data-quiz-panel="intro"]'),
      questions: root.querySelector('[data-quiz-panel="questions"]'),
      result: root.querySelector('[data-quiz-panel="result"]')
    };
    var images = {
      both: root.querySelector('[data-quiz-image="both"]'),
      libre: root.querySelector('[data-quiz-image="libre"]'),
      airy: root.querySelector('[data-quiz-image="airy"]')
    };
    var startBtn = root.querySelector('[data-quiz-start]');
    var exitBtn = root.querySelector('[data-quiz-exit]');
    var retakeBtns = root.querySelectorAll('[data-quiz-retake]');
    var countEl = root.querySelector('[data-quiz-count]');
    var progressEl = root.querySelector('[data-quiz-progress]');
    var questionEl = root.querySelector('[data-quiz-question]');
    var optionsEl = root.querySelector('[data-quiz-options]');

    var resultSingle = root.querySelector('[data-quiz-result-single]');
    var resultTie = root.querySelector('[data-quiz-result-tie]');
    var resultTitle = root.querySelector('[data-quiz-result-title]');
    var resultBody = root.querySelector('[data-quiz-result-body]');
    var resultCta = root.querySelector('[data-quiz-result-cta]');
    var resultDetails = root.querySelector('[data-quiz-result-details]');

    var state = { qIdx: 0, selected: null, airy: 0, libre: 0, answers: [] };

    function showPanel(name) {
      Object.keys(panels).forEach(function (key) {
        if (panels[key]) panels[key].hidden = key !== name;
      });
    }

    function showImage(name) {
      Object.keys(images).forEach(function (key) {
        if (images[key]) images[key].hidden = key !== name;
      });
    }

    function reset() {
      state = { qIdx: 0, selected: null, airy: 0, libre: 0, answers: [] };
      showPanel('intro');
      showImage('both');
    }

    function renderQuestion() {
      var q = QUESTIONS[state.qIdx];
      countEl.textContent = (state.qIdx + 1) + ' / ' + QUESTIONS.length;
      progressEl.style.width = ((state.qIdx / QUESTIONS.length) * 100) + '%';
      questionEl.textContent = q.q;
      optionsEl.innerHTML = '';
      q.options.forEach(function (opt, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quiz-option';
        btn.innerHTML = '<span class="quiz-option__dot"></span><span class="quiz-option__label">' + opt.label + '</span>';
        btn.addEventListener('click', function () { pick(i); });
        optionsEl.appendChild(btn);
      });
    }

    function pick(i) {
      var q = QUESTIONS[state.qIdx];
      var opt = q.options[i];
      state.airy += opt.airy;
      state.libre += opt.libre;

      var optionBtns = optionsEl.querySelectorAll('.quiz-option');
      optionBtns.forEach(function (b, idx) {
        b.classList.toggle('is-selected', idx === i);
      });

      setTimeout(function () {
        if (state.qIdx < QUESTIONS.length - 1) {
          state.qIdx += 1;
          renderQuestion();
        } else {
          showResult();
        }
      }, 260);
    }

    function showResult() {
      showPanel('result');
      var isTie = state.airy === state.libre;

      if (isTie) {
        resultSingle.hidden = true;
        resultTie.hidden = false;
        showImage('both');
        return;
      }

      resultTie.hidden = true;
      resultSingle.hidden = false;

      var isAiry = state.airy > state.libre;
      var copy = isAiry ? RESULT_COPY.airy : RESULT_COPY.libre;
      resultTitle.textContent = copy.title;
      resultBody.textContent = copy.body;

      var url = isAiry ? data.airyUrl : data.libreUrl;
      if (resultCta) resultCta.setAttribute('href', url || '#');
      if (resultDetails) resultDetails.setAttribute('href', url || '#');

      showImage(isAiry ? 'airy' : 'libre');
    }

    if (startBtn) startBtn.addEventListener('click', function () {
      state.qIdx = 0;
      showPanel('questions');
      renderQuestion();
    });

    if (exitBtn) exitBtn.addEventListener('click', reset);
    retakeBtns.forEach(function (btn) { btn.addEventListener('click', reset); });

    reset();
  }

  function initAll() {
    document.querySelectorAll('[data-quiz-root]').forEach(function (root) {
      initQuiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();